import { useEffect } from "react";

export const PRECON_MODULE_BODY_CLASS = "ciq-precon-module";

/**
 * Tags `<body>` while a Design Packages / Design Scope / Bid Packages screen is
 * mounted, so src/antd-override.scss can theme delete icons and Unlink actions
 * for those modules only. It lives on `<body>` rather than a page wrapper
 * because antd modals, dropdowns and popconfirms portal there.
 */
export function usePreconModuleBodyClass(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    document.body.classList.add(PRECON_MODULE_BODY_CLASS);
    return () => {
      document.body.classList.remove(PRECON_MODULE_BODY_CLASS);
    };
  }, [active]);
}

export default usePreconModuleBodyClass;
